import $ from "jquery";
import { Fragment, useContext, useState } from "react";
import InputRange from "react-input-range";
import MyContext from "../../../../02Contexts/Mycontext";
import { BiArrowBack, BiMap, BiPhone, BiStoreAlt } from "react-icons/bi";
import CustomItemCardWidget from "../../../../00Widgets/CustomItemCardWidget/CustomItemCardWidget";
// import CustomInputWidget from '../../../../00Widgets/CustomInputWidget/CustomInputWidget';
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import Select from "react-select";
import { BsSearch, BsCreditCard } from "react-icons/bs";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BiSlider } from "react-icons/bi";
import "./sideBarComponent.scss";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import logo from "../logo.png";
import error from "../error-img.png";
import CardItemsWidget from "../../../../00Widgets/CardItemsWidget/CardItemsWidget";

export default function SideBarComponent() {
  function toggleFilter() {
    $("#filter_component").toggleClass("active");
  }

  const {
    location,
    setLocation,
    radius,
    setRadius,
    list,
    setList,
    details,
    setDetails,
    map,
    productList,
    productType,
    setProductType,
    inputRadius,
    setInputRadius,
  } = useContext(MyContext);

  function maskPhone(phone) {
    if (phone) {
      if (phone.length === 11) {
        return `(${phone.substr(0, 2)})  ${phone.substr(2, 1)} ${phone.substr(
          3,
          4
        )}-${phone.substr(7, 8)}`;
      } else {
        return `(${phone.substr(0, 2)}) ${phone.substr(2, 4)}-${phone.substr(
          6,
          7
        )}`;
      }
    } else {
      return "Sem telefone";
    }
  }

  return (
    <Fragment>
      <MyContext.Provider
        value={{
          location,
          setLocation,
          radius,
          setRadius,
          setInputRadius,
          list,
          setList,
          details,
          setDetails,
          map,
          productList,
          productType,
          setProductType,
        }}
      >
        {!details ? (
          <div id="input_component" className="pt-1">
            <div id="child_header">
              <img src={logo} alt="logo" id="viasoft_logo" className="py-2" />
              <p className="text-black">Uma plataforma. Todos os benefícios.</p>
            </div>
            <div id="scroll_child" className="pt-3">
              <p className="note">
                {" "}
                Visualizando {list.length} estabelecimentos em um raio de{" "}
                {inputRadius} km.
              </p>
              {/* < p className='note' > Visualizando {list.length} estabelecimentos em um raio de {radius / 1000} km</p > */}
              <div id="filter_btn_container">
                <button
                  className="custom_btn"
                  id="filter_btn"
                  onClick={(e) => toggleFilter()}
                >
                  <BiSlider />
                  <p>Filtro</p>
                </button>
              </div>
              <FiltroComponent />

              <ResultComponent />
            </div>
          </div>
        ) : (
          <div id="input_component">
            <div className="details_container">
              <div
                className="back_container"
                onClick={(e) => {
                  setDetails(null);
                  if ($(window).width() > 980) {
                    map.closePopup();
                    map.flyTo(location, 14, { duration: 0.4 });
                  }
                }}
              >
                <BiArrowBack color="black" size="1.2rem" className="back_btn" />
                <p className="text-blue">Voltar para lista de resultados</p>
              </div>
              <h3 className="text-color2">{details.name}</h3>

              <CustomItemCardWidget
                title="Bairro"
                info={details.city}
                icon={<BiMap color="var(--color2)" size="1.5rem" />}
              />

              <CustomItemCardWidget
                title="Endereço"
                info={details.adress}
                icon={<BiMap color="var(--color2)" size="1.5rem" />}
              />

              <CustomItemCardWidget
                title="Segmento"
                info={details.segmento}
                icon={<BiStoreAlt color="var(--color2)" size="1.5rem" />}
              />

              <CustomItemCardWidget
                title="Telefone"
                info={maskPhone(details.phone)}
                icon={<BiPhone color="var(--color2)" size="1.5rem" />}
              />

              <CustomItemCardWidget
                title="Funcionamento"
                info={details.fulltime ? "24 horas" : details.time}
                icon={
                  <AiOutlineClockCircle color="var(--color2)" size="1.5rem" />
                }
              />

              <CustomItemCardWidget
                title="Benefícios aceitos"
                info={
                  <CardItemsWidget
                    productList={productList}
                    values={details.cards}
                  />
                }
                icon={<BsCreditCard color="var(--color2)" size="1.5rem" />}
              />
            </div>
          </div>
        )}
      </MyContext.Provider>
    </Fragment>
  );
}

export function FiltroComponent() {
  const {
    setLocation,
    radius,
    setRadius,
    map,
    productList,
    productType,
    setProductType,
    setInputRadius,
    setDetails,
  } = useContext(MyContext);

  const [adress, setAdress] = useState("");

  const handleAdress = (value) => setAdress(value);

  let ind = productList.map((item) => item.value).indexOf(productType);

  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) =>
        getLatLng(
          results.length === 1
            ? results[0]
            : results.filter((item) => item.formatted_address === address)[0] ||
                results[0]
        )
      )
      .then((latLng) => {
        setLocation(latLng);
        map.flyTo(latLng, 13, { duration: 0.4 });
      })
      .catch((error) => console.error("Error", error));
  };

  return (
    <div id="filter_component">
      <div className="range_input">
        <Select
          options={productList}
          defaultValue={productList[ind]}
          onChange={(e) => setProductType(e.value)}
        />
      </div>
      <div className="range_input">
        <PlacesAutocomplete
          value={adress}
          searchOptions={{ componentRestrictions: { country: "br" } }}
          onChange={handleAdress}
          onSelect={handleSelect}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => (
            <div className="w-100">
              <div className="custom_input">
                <BsSearch size="1.5rem" color="var(--color2)" />
                <input
                  {...getInputProps({
                    placeholder: "Para onde vamos?",
                  })}
                />
              </div>

              <div id="search_options">
                {loading && <div>Carregando</div>}
                {suggestions.map((item, index) => {
                  return (
                    <div
                      {...getSuggestionItemProps(item)}
                      className="search_result_option"
                      key={item.placeId + index}
                    >
                      <p>{item.description}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>
      <div className="range_input">
        <h4 id="raio">Raio</h4>
        <InputRange
          valueLabel="1"
          maxValue={50}
          minValue={1}
          value={radius / 1000}
          onChange={(value) => setRadius(value * 1000)}
        />
      </div>
      <button
        className="custom_btn full"
        onClick={(e) => {
          setInputRadius(radius / 1000);
          setDetails(null);
          $("#filter_component").removeClass("active");
        }}
      >
        Pesquisar
      </button>
    </div>
  );
}

export function ResultComponent() {
  const { list, setDetails, map } = useContext(MyContext);
  return (
    <Fragment>
      {list.length ? (
        <div className="result_container">
          {list.map((item, index) => {
            return (
              <div
                className="item_card"
                key={item.name + index}
                onClick={(e) => {
                  setDetails(item);
                  if ($(window).width() > 980) {
                    map.flyTo(item.location, 17, { duration: 0.4 });
                    // map.openPopup();
                  }
                }}
              >
                <p className="card_title">{item.name}</p>
                <p className="note">{item.adress}</p>
              </div>
            );
          })}
        </div>
      ) : (
        <div className=" result_container error_container mt-5">
          <img src={error} alt="logo" id="error_img" />
          <h5 className="px-3 mt-5">
            Desculpe, não temos nenhum estabelecimento na região
          </h5>
          <button
            onClick={(e) => {
              $("#filter_component").addClass("active");
            }}
            className="custom_btn full mt-3"
          >
            Relizar uma nova busca
          </button>
        </div>
      )}
    </Fragment>
  );
}
